import React from 'react';
import '../styles/layouts/footer.scss'
import { Link } from 'react-router-dom';
import { Container, List, ListItem, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import facebook from '../assets/icons/facebook.svg';
import whastapp from '../assets/icons/whatsapp.svg';
import instagram from '../assets/icons/instagram.svg';
import youtube from '../assets/icons/youtube.svg';
import linkedin from '../assets/icons/linkedin.svg';
import phone from '../assets/icons/phone.svg';
import email from '../assets/icons/mail.svg';
import playstore from '../assets/icons/playstore.png';
import appstore from '../assets/icons/apple (2).png';

const Footer = () => {
  return (
    <React.Fragment>
      <section className="footer-section">
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 2.5 }}>
              <div className='footer-content'>
                <List>
                  <Typography variant='h6'>Explore</Typography>
                  <ListItem>
                    <Link to='/about'>About us</Link>
                  </ListItem>
                  {/* <ListItem>
                    <Link>Fabric Guide</Link>
                  </ListItem> */}
                  <ListItem>
                    <Link to='/faq'>FAQ’s</Link>
                  </ListItem>
                </List>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 2.5 }}>
              <div className='footer-content'>
                <List>
                  <Typography variant='h6'>Our Policies</Typography>
                  <ListItem>
                    <Link to='/privacypolicy'>Privacy Policy</Link>
                  </ListItem>
                  <ListItem>
                    <Link to='/termsconditions'>Terms & Conditions</Link>
                  </ListItem>
                  <ListItem>
                    <Link to="/shippingpolicy">Shipping Policy</Link>
                  </ListItem>
                  <ListItem>
                    <Link to="/refundcancellation">Cancellation & Refund</Link>
                  </ListItem>

                </List>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 3 }}>
              <div className='footer-content'>
                <List>
                  <Typography variant='h6'>Download</Typography>
                  {/* <ListItem>
                    <Link>App store</Link>
                  </ListItem> */}
                  <ListItem>
                    <Link to="https://play.google.com/store/apps/details?id=com.tailor4u.user&pcampaignid=web_share" target='_blank'>     <img src={playstore} alt='playstore' />Play Store</Link>
                  </ListItem>

                  <ListItem>
                    <Link to="https://apps.apple.com/in/app/tailors4u/id6758755806" target='_blank'>
                      <img src={appstore} alt='appstore' />App Store
                    </Link>
                  </ListItem>
                </List>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
              <div className='footer-content'>
                <List>
                  <Typography variant='h6'>Contact Us</Typography>
                  <ListItem>
                    For Orders : <a href="tel:+919063939524">9063939524</a>
                  </ListItem>
                  <ListItem>
                    For Concerns :
                    <a href="tel:+919063939527"> 9063939527</a>
                    {"  /  "}
                    <a href="tel:+919063939528"> 9063939528</a>
                  </ListItem>

                  <ListItem>
                    <a href="tel:+919036074200"><img src={phone} alt='phone' />+91 9036074200</a>
                  </ListItem>
                  <ListItem>
                    <a href="mailto:tailors4u2025@gmail.com"><img src={email} alt='email' />support@tailors4u.com</a>
                  </ListItem>
                </List>
              </div>
            </Grid>
          </Grid>
        </Container>
        <div className='copyrihgt-title'>
          <Container maxWidth="xl">
            <Grid container spacing={2}>
              <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <List>
                  <ListItem><Link><img src={facebook} alt='facebook' /></Link></ListItem>
                  <ListItem><Link><img src={whastapp} alt='whastapp' /></Link></ListItem>
                  <ListItem><Link><img src={instagram} alt='instagram' /></Link></ListItem>
                  <ListItem><Link><img src={youtube} alt='youtube' /></Link></ListItem>
                  <ListItem><Link><img src={linkedin} alt='linkedin' /></Link></ListItem>
                </List>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <List>
                  <ListItem>
                    <Typography>Copyright <span>© 2025 all rights reserved @ ARYADITYA FASHIONS PRIVATE LIMITED | Developed By <a href='https://www.vibhotech.com/' target='_blank' style={{ textDecoration: "none", color: "#fff" }}>Vibho Technologies</a></span></Typography>
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Container>
        </div>
      </section>
    </React.Fragment>
  )
}

export default Footer